// LT = Login Type
export const LT_MSID = 'msid';
export const LT_OHID = 'ohid';
export const LT_OHID_SESSION = 'OH_AUTH'; // New OHID config role
export const LT_MSID_SESSION = 'MS_AUTH'; // New OHID config role
export const LT_DOMAIN = 'UTAH';

export const MSID_VERIFIER_COOKIE_NAME_SECURE = '__Secure-mv';
export const MSID_VERIFIER_COOKIE_NAME = '__mv';
export const OHID_VERIFIER_COOKIE_NAME_SECURE = '__Secure-ov';
export const OHID_VERIFIER_COOKIE_NAME = '__ov';
export const SESSION_ID_COOKIE_NAME_HOST = '__Host-sid';
export const SESSION_ID_COOKIE_NAME = 'sid';
export const SESSION_TYPE = '__st';
export const SESSION_TYPE_HOST = '__Host-st';
export const DOMAIN_COOKIE_NAME = '__dm';
export const DOMAIN_COOKIE_NAME_HOST = '__Host-dm';

export const PRODUCTION = 'production';

export const ERROR_CODE_UPSTREAM_UNREACHABLE = '00003';
// FF = Feature Flag (feature contants)
export const FEATURE_FLAG_UA = {
  REMITTANCE: 'remittancesummary',
  USER_MGMT: 'userManagement',
  DOC_MGMT: 'docManagement',
  MEMBER_SEARCH: 'memberSearch'
};

// FS = Feature Status (feature status constants)
export const FS_VIEW = 'view';
// @Todo: Need to change these value according to UTAH
export const PROTECTED_GROUP_IDS = ['TST-WYM'];
export const CUSTOM_SITE_CLIENT_ID = 'WYM';

export const PROTECTED_ROUTES = ['/', '/home', '/user-management', '/member-search'];
export const NON_PROTECTED_ROUTES = ['/', '/prelogin', '/prelogin/msid', '/prelogin/ohid'];
export const AUTH_PROCTECTED_ROUTES = {
  [LT_MSID_SESSION]: ['/', '/home', '/user-management'],
  [LT_OHID_SESSION]: ['/', '/home', '/remittance-summary', '/member-search']
};

export const EMPTY_VALUE = '—';
export const PHONE_PATTERN = /^(\d{3})(\d{3})(\d{4})$/;
